import ApplicationSerializer from 'eflex/serializers/application';

export default class MultispindleProcessDatumSerializer extends ApplicationSerializer {
  attrs = {
    buildStatusChild: {
      deserialize: false,
      serialize: false,
    },
    spindles: {
      embedded: 'always',
    },
  };
}
